import { render, staticRenderFns } from "./NumberAnimation.vue?vue&type=template&id=6251788b"
import script from "./NumberAnimation.vue?vue&type=script&lang=js"
export * from "./NumberAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports